export { default } from './Numbers.container'



// WEBPACK FOOTER //
// ./src/pages/Numbers/index.js